import { c as _c } from "react/compiler-runtime";
import { QuestionMarkInCircleIcon, Tooltip } from "@flat-ui";
import { Box } from "@mui-wrapper";
/** Size for the help icon that activates the tooltip */
const ICON_SIZE = "16px";
/** Renders an icon that shows a tooltip text when hovered */
export function SphereTooltipIcon(t0) {
  const $ = _c(11);
  const {
    text,
    icon: t1,
    size: t2,
    tooltipProps,
    dataTestId
  } = t0;
  const icon = t1 === undefined ? QuestionMarkInCircleIcon : t1;
  const size = t2 === undefined ? ICON_SIZE : t2;
  const Icon = icon;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      alignItems: "center"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[1] = size;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== Icon || $[4] !== t4) {
    t5 = <Icon sx={t4} />;
    $[3] = Icon;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== dataTestId || $[7] !== t5 || $[8] !== text || $[9] !== tooltipProps) {
    t6 = <Box component="div"><Tooltip component="div" title={text} enterDelay={0} enterNextDelay={0} sx={t3} data-testid={dataTestId} {...tooltipProps}>{t5}</Tooltip></Box>;
    $[6] = dataTestId;
    $[7] = t5;
    $[8] = text;
    $[9] = tooltipProps;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}